<template>
	<div>
		<EbHeading level="h1" class="eb-page-heading">Choix du type de déclaration</EbHeading>
		<div class="md:grid md:grid-cols-2 md:grid-rows-2 md:gap-16">
			<div class="eb-card col-span-full flex md:align-items-center">
				<font-awesome-icon :icon="['fas', 'house-user']" size="3x" class="mr-16 md:m-24" :style="{color: '#1E22AE'}" />
				<EbLinkButton :to="{name: 'accueilDeclaration'}" class="secondary small mb-24 text-center">Déclarer l'accueil d'un enfant</EbLinkButton>
        <p>Vous devez déclarer dans les huit jours suivant l'accueil, le nom et la date de naissance des mineurs ainsi que les modalités d'accueil et les coordonnées des représentants légaux. Toute modification de l'un de ces éléments ou départ définitif de l’enfant doit également être déclaré dans les huit jours.</p>
			</div>
      <div class="eb-card col-span-full flex"><EbHeading level="h2">Si votre agrément vous permet un accueil dérogatoire :</EbHeading></div>
			<div class="eb-card flex flex-col">
				<div class="flex flex-row md:flex-col md:align-items-center">
					<font-awesome-layers class="fa-3x mr-36 md:m-24">
						<font-awesome-icon :icon="['fas', 'house-user']" size="2x" :style="{color: '#C0D0DE'}" />
						<font-awesome-layers>
							<font-awesome-icon :icon="['fas', 'square']" size="xs" transform="shrink-2 right-12 " :style="{color: '#1E22AE'}" />
							<font-awesome-icon :icon="['fas', 'hourglass-half']" size="xs" transform="shrink-10 right-12 " inverse />
						</font-awesome-layers>
					</font-awesome-layers>
					<EbLinkButton :to="{name: 'accueilSupplementaire'}" class="secondary small mb-24 text-center">Déclarer un accueil supplémentaire à titre ponctuel</EbLinkButton>
				</div>
				<EbDisclosure label="En savoir plus sur les conditions de cet accueil supplémentaire" groupTag="div">
					<cite>(cf. Art. L 421-4-1-II et D 421-17 III du CASF) :</cite>
					<ul>
						<li>50 heures maximum par mois sous réserve du respect des conditions de sécurité suffisantes</li>
						<li>
							Pour le remplacement d’une collègue momentanément indisponible, pour l’accueil d’un enfant dont le parent est engagé dans un parcours d’insertion sociale et professionnelle
						</li>
						<li>Un seul enfant de plus que le nombre de mineurs fixés par son agrément</li>
						<li>Toujours dans la limite de 6 enfants de moins de 11 ans sous sa responsabilité exclusive dont au maximum 4 enfants de moins de 3 ans</li>
						<li>L’assistante maternelle doit en informer tous les parents</li>
					</ul>
				</EbDisclosure>
			</div>
			<div class="eb-card flex flex-col">
				<div class="flex flex-row md:flex-col md:align-items-center">
					<font-awesome-layers class="fa-3x mr-36 md:m-24">
						<font-awesome-icon :icon="['fas', 'house-user']" size="2x" :style="{color: '#C0D0DE'}" />
						<font-awesome-icon :icon="['fas', 'users']" transform="shrink-6 down-2" inverse />
						<font-awesome-layers>
							<font-awesome-icon :icon="['fas', 'square']" size="xs" transform="shrink-2 right-12 " :style="{color: '#1E22AE'}" />
							<font-awesome-icon :icon="['fas', 'user-plus']" size="xs" transform="shrink-10 right-12 " inverse />
						</font-awesome-layers>
					</font-awesome-layers>
					<EbLinkButton :to="{name: 'accueilSurnombre'}" class="secondary small mb-24 text-center">Déclarer un accueil en surnombre à titre exceptionnel</EbLinkButton>
				</div>

				<EbDisclosure label="En savoir plus sur les conditions de cet accueil en surnombre" groupTag="div">
					<cite>(cf. Art L. 421-4- II, article D 421-17-1, R421-39 du CASF) :</cite>
					<ul>
						<li>55 jours maximum par an sous réserve du respect des conditions de sécurité suffisantes</li>
						<li>
							De manière limitée dans le temps pour répondre à un besoin temporaire notamment lors de vacances scolaires ou un besoin imprévisible : pour 1 ou 2 enfants de plus (7 ou 8 mineurs de moins de 11 ans) toujours dans la limite de 4 enfants de moins de 3 ans
						</li>
					</ul>
				</EbDisclosure>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'choixAccueil'
}
</script>
